import {
  ReviewCycleKind,
  ReviewerType,
  type ReviewForm,
} from '@gokrew/models/performance';

/**
 * Team feedback on managers (spec 2026-10-29 upward feedback): pure helpers
 * shared by the create flow, the cycle pages and the editors.
 */

/** The team feedback settings of a cycle's editor values. */
export const teamSettingsOf = (
  cycle?: {
    upwardDueDate: string | null;
    upwardIncludeIndirect: boolean;
  } | null
) => ({
  upwardDueDate: cycle?.upwardDueDate ?? null,
  upwardIncludeIndirect: cycle?.upwardIncludeIndirect ?? false,
});

/** A team feedback cycle: reviewees are managers, reviewers their team. */
export const isTeamFeedback = (cycle?: { kind?: ReviewCycleKind } | null) =>
  cycle?.kind === ReviewCycleKind.UPWARD;

/** Every question is the team's alone: a team feedback form by its shape. */
export const isTeamOnlyForm = (form?: ReviewForm | null): boolean => {
  const questions = (form?.sections ?? []).flatMap((s) => s.questions);
  return (
    questions.length > 0 &&
    questions.every(
      (q) =>
        q.reviewerTypes.length > 0 &&
        q.reviewerTypes.every((type) => type === ReviewerType.UPWARD)
    )
  );
};

/** The cycle kind a template starts: team feedback for a team-only form. */
export const kindOfCustomForm = (form: ReviewForm): ReviewCycleKind =>
  isTeamOnlyForm(form) ? ReviewCycleKind.UPWARD : ReviewCycleKind.AD_HOC;

/** "3 / 4 (75 %)": answered, asked and the rate, never who. */
export const responseLine = (
  counts: { invited: number; submitted: number } | null | undefined
) =>
  counts
    ? {
        ...counts,
        rate: counts.invited
          ? Math.round((counts.submitted / counts.invited) * 100)
          : null,
      }
    : null;
